<template>
  <div class="leadlist-step-6">
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else class="resume-box mt-5">
      <div>
        <strong>
          {{ provider === "Active Campaign" ? "Tag" : "Nome" }}:
        </strong>
        {{ form.name }}
      </div>
      <div><strong>Provedor:</strong> {{ provider }}</div>
      <div><strong>Evento:</strong> {{ eventName }}</div>
      <div><strong>Comando:</strong> {{ command }}</div>
      <div v-if="provider === 'Lead Lovers'">
        <strong>Tag:</strong> {{ tag }}
      </div>
      <div v-if="provider === 'RD Station'">
        <strong>Tags:</strong> {{ tags }}
      </div>
      <!-- <div v-if="form.values">
        <strong>Valores:</strong> {{ form.values.join(" ▪ ") }}
      </div> -->
      <!-- <div v-if="form.segmentation_list && form.segmentation_list.length">
        <strong>Lista:</strong> {{ form.segmentation_list }}
      </div> -->
      <!-- <div v-if="form.tags">
        <strong>Adicionar tags:</strong> {{ form.tags }}
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({ loading: false }),
  mounted() {
    if (this.providers.length === 0) {
      this.loading = true;
      this.$store
        .dispatch("integration/getProviders")
        .then()
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapState("integration", [
      "tags",
      "providers",
      "typeEvents",
      "typeCommands",
      "mapProviderName"
    ]),
    provider() {
      const provider = this.providers.find(
        p => p.id === this.form.integration_id
      );

      if (!provider) return "-";

      return this.mapProviderName[provider.name];
    },
    command() {
      const command = this.typeCommands.find(p => p.id === this.form.command);

      if (!command) return "-";

      return command.name;
    },
    tag() {
      const tagObj = this.tags.find(t => t.id === this.form.tag);

      if (!tagObj) return "-";

      return tagObj.name;
    },
    tags() {
      return this.form.tags;
    },
    eventName() {
      const eventObj = this.typeEvents.find(p => p.id === this.form.event);

      if (!eventObj) return "-";

      return eventObj.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.leadlist-step-6 {
  .resume-box {
    gap: 8px;
    display: flex;
    padding: 12px 16px;
    flex-direction: column;
    border-radius: 4px;
    background: rgba(105, 106, 126, 0.02);
    border: 1px solid rgba(219, 221, 230, 0.85);

    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(59, 59, 74, 0.9);

    strong {
      color: rgba(38, 36, 50, 0.93);

      font-weight: 500;
    }
  }
}
</style>
